function cardBody() {
    return {
        componentName: 'cardBody',
        baseStyle: {
            flexBasis: '100%'
        }
    };
}

export { cardBody as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FyZEJvZHkuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9jb21wb25lbnRzL2NhcmQvY2FyZEJvZHkudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQ29tcG9uZW50U3R5bGUgfSBmcm9tICcuLi8uLi90eXBlcyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNhcmRCb2R5KCk6IENvbXBvbmVudFN0eWxlIHtcbiAgcmV0dXJuIHtcbiAgICBjb21wb25lbnROYW1lOiAnY2FyZEJvZHknLFxuICAgIGJhc2VTdHlsZToge1xuICAgICAgZmxleEJhc2lzOiAnMTAwJSdcbiAgICB9XG4gIH07XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRWMsU0FBVSxRQUFRLEdBQUE7SUFDOUIsT0FBTztBQUNMLFFBQUEsYUFBYSxFQUFFLFVBQVU7QUFDekIsUUFBQSxTQUFTLEVBQUU7QUFDVCxZQUFBLFNBQVMsRUFBRTtBQUNaO0tBQ0Y7QUFDSDs7OzsifQ==
